import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import Help from "../../Components/Help/Help";
import { serviceConsumer } from "../../network/ServiceConsumer";
import { sortGrades } from "../../helper/SortSyllabus";
import { isEventToday, pageStateForEvent } from "../../helper/eventFeed";
import { inLateWindow } from "../../helper/lateEntries";
import EventSite from "../EventSite/EventSite";
import { shortDay } from "../EventSite/eventSiteModel";

const GradeViewEvent = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const searchParams = new URLSearchParams(search)
  const eventId = searchParams.get('id')
  const [collaborators, setCollaborators] = useState()
  const [eventProp, setEventProp] = useState()
  const [urlEventName, setUrlEventName] = useState()
  const [grades, setGrades] = useState([])

  //getting details from passed events
  // A shared or typed link has no router state: use the exam's own dates.
  let event = state?.from || pageStateForEvent(eventProp && { ...eventProp, eventType: "Grade Exam" });

  const getInitialDetails = async () => {
    try {
      setLoading(true);
      const eventUrl = localStorage.getItem("accessToken") ? `${process.env.REACT_APP_BASE_URL}/grade-exam/${eventId}` : `${process.env.REACT_APP_BASE_URL}/grade-exam/single/${eventId}`
      const eventResponse = await serviceConsumer('GET', eventUrl)
      const eventNameForUrl = eventResponse?.grade_exams?.name?.split(" ").join("+");
      setUrlEventName(eventNameForUrl)
      setEventProp(eventResponse.grade_exams)
      document.title = `Feis.link - ${eventResponse?.grade_exams?.name}`;
      const collaboratorsUrl = `${process.env.REACT_APP_BASE_URL}/grade-exam/collaborators/${eventId}`
      const collaboratorsResponse = await serviceConsumer('GET', collaboratorsUrl)
      setCollaborators(collaboratorsResponse.result)
      setGrades(sortGrades(collaboratorsResponse.result.grades))
      setLoading(false)
    } catch (error) {
      navigate("pageNotFound", { replace: true })
      setLoading(false)
    }
  };

  // if there isd no data it will navigate to ther home page
  useEffect(() => {
    window.scrollTo(0, 0);
    getInitialDetails()
  }, []);

  //button handlers
  const backToViewEvent = () => {
    window.history.go(-1);
  };
  const goToRegisgternow = () => {
    if (localStorage.getItem("accessToken")) {
      navigate(`/register-grade-exam?id=${eventProp?._id}`, {
        state: { event: eventProp },
      });
    } else {
      localStorage.setItem("path", `/grade/${eventProp?.name}?id=${eventId}`);
      localStorage.setItem("eventId", eventProp._id);
      localStorage.setItem("from", "open");
      localStorage.setItem("eventType", eventProp?.eventType);
      navigate("/login");
    }
  };


  setTimeout(() => {
    setLoading(false);
  }, 1000);


  // the header's state pill and buttons, as on the dashboard's cards
  const actions = eventProp ? [
    event === "upcoming" && {
      key: "register", icon: "how_to_reg", primary: true, disabled: true,
      label: eventProp?.opening_date ? `Registration opens ${shortDay(eventProp.opening_date)}` : "Registration not open yet",
    },
    event === "open" && { key: "register", icon: "how_to_reg", primary: true, label: "Register", onClick: goToRegisgternow },
  ].filter(Boolean) : [];

  return (
    <div>
      {loading && <Loader />}
      {!loading && eventProp && (
        <EventSite
          event={eventProp}
          kind="grade"
          state={isEventToday(eventProp && { ...eventProp, eventType: "Grade Exam" }) ? "today" : event === "open" && inLateWindow(eventProp) ? "late" : event}
          actions={actions}
          collaborators={collaborators}
          grades={grades}
          backLabel="Back"
          onBack={backToViewEvent}
        />
      )}
      <Help />
    </div>
  );
};

export default GradeViewEvent;
